import type { PreloadConfig } from '@preload/graphql/getConfig.d'

export type FrontendPreloadConfig = PreloadConfig &
    {
        [K in keyof Omit<PreloadConfig, '__typename'>]?: PreloadConfig[K] & {
            queryPath?: string
            fetchConfig?: Record<string, unknown>
        }
    }

export const CHECKOUT_GUEST_INFO = 'checkout_guest_info'
export const CHECKOUT_CUSTOMER_INFO = 'checkout_customer_info'
export const ACCOUNT_CREATION_BENEFIT = 'account_creation_benefit'
export const CHECKOUT_ALPHA_CONSENT = 'checkout_alfa_consent'
export const CHECKOUT_FOOTER_COPYRIGHT = 'footer-copyright-block-checkout'
export const CHECKOUT_AGE_VERIFICATION_MESSAGE =
    'checkout_age_verfication_message'
export const CUSTOMER_REVIEW_BLOCK = 'checkout_review_block'
export const SAFE_SECURE_BLOCK = 'safe_secure_block'
export const CHECKOUT_CMS_BLOCKS = 'checkoutBlocks'
export const FOOTER_CMS_BLOCKS = 'footer'
export const BLOG_CMS_BLOCKS = 'blogBlocks'
export const MY_DEVICES_BLOCKS = 'MyDevice'
export const CHECKOUT_TERMS_CONDITION = 'CheckoutAgreements'
export const THCA_DISCLAMER = 'thca_disclaimer'

const CMS_QUERY_PATH = 'framework/pylot/hooks/cms/graphql/getCMSBlocks.ts'
export const preload: FrontendPreloadConfig = {
    menu: {
        queryPath:
            'framework/pylot/hooks/category/graphql/navigationMenuWithCMSBlocks.ts'
    },
    header: {
        variables: {
            identifiers: []
        },
        queryPath: CMS_QUERY_PATH
    },
    [FOOTER_CMS_BLOCKS]: {
        variables: {
            identifiers: [
                'footer-copyright-block',
                'footer_links',
                'footer-social-media',
                'unique-selling-proposition-slider'
            ]
        },
        queryPath: CMS_QUERY_PATH,
        role: {
            copyright: 'footer-copyright-block',
            links: 'footer_links',
            social: 'footer-social-media',
            unique: 'unique-selling-proposition-slider'
        }
    },
    countries: {
        variables: {},
        queryPath:
            'components/alfakher/pylot-utils/src/hooks/graphql/countryQuery.ts'
    },
    [CHECKOUT_CMS_BLOCKS]: {
        variables: {
            identifiers: [
                CHECKOUT_ALPHA_CONSENT,
                CHECKOUT_GUEST_INFO,
                ACCOUNT_CREATION_BENEFIT,
                CHECKOUT_AGE_VERIFICATION_MESSAGE,
                CUSTOMER_REVIEW_BLOCK,
                SAFE_SECURE_BLOCK
            ]
        },
        queryPath: CMS_QUERY_PATH
    },
    [BLOG_CMS_BLOCKS]: {
        variables: {
            identifiers: [
                'sidebar-banner-1',
                'blog_shop_now',
                'you_may_also_like'
            ]
        },
        queryPath: CMS_QUERY_PATH
    },
    [MY_DEVICES_BLOCKS]: {
        variables: {
            identifiers: []
        },
        queryPath: CMS_QUERY_PATH
    },
    [CHECKOUT_TERMS_CONDITION]: {
        variables: {},
        queryPath: 'framework/pylot/hooks/cms/graphql/getCheckoutAgreement.ts'
    },
    [THCA_DISCLAMER]: {
        variables: {
            identifiers: [THCA_DISCLAMER]
        },
        queryPath: CMS_QUERY_PATH
    }
}

export default preload
